import { apis } from 'utils/lib/apis';
import * as Actions from "./actions";
import { logToSentry } from "utils/networkErrorUtils";
import { handleListClassGameActivity } from 'store/one_game/thunks';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { updateUI } from 'store/UI/actions';
import { getFirestore } from 'firebase/firestore';
import { firebaseApp } from 'firebaseConfig';
import { doc, deleteDoc } from 'firebase/firestore';

export const handleListWorkSheet =
  (chapter, role, userId, limit = 10, offset = 0, status = true, bugFilter = false, classId = null) =>
  async (dispatch) => {
    const data = {
      chapter,
      role,
      user_id: userId,
      limit: limit,
      offset: offset,
      status,
      is_bug: bugFilter,
      class_id: classId,
    };
    try {
      const workSheetData = await apis.post("oneway_bingo", `/listWorksheet`, {
        body: data,
      });

      if (Array.isArray(workSheetData)) {
        const sortedFilterStatus = [...workSheetData].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        await dispatch(Actions.setListWorkSheet(sortedFilterStatus));
      }

      return workSheetData;
    } catch (error) {
      if (error && error.message != "Network Error") {
        logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'LIST_WORKSHEET'
            });
      }
    }
  };

export const handleListWorkSheetUnverified = (chapter, role, userId, limit = 10, offset = 0, status = true, bugFilter = false) => async (dispatch) => {
    const data = {
      chapter,
      role,
      user_id: userId,
      limit: limit,
      offset: offset,
      status,
      is_verified: false,
      is_bug: bugFilter,
    };
    try {
      const workSheetData = await apis.post("oneway_bingo", `/listWorksheet`, {
        body: data,
      });

      if (Array.isArray(workSheetData)) {
        const sortedFilterStatus = [...workSheetData].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        await dispatch(Actions.setListWorkSheet(sortedFilterStatus));
      }

      return workSheetData;
    } catch (error) {
      if (error && error.message != "Network Error") {
        logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'LIST_WORKSHEET'
            });
      }
    }
  };

export const handleListQuestionOfWorksheet = (id) => async (dispatch) => {
  try {
    const workSheetData = await apis.get(
      "oneway_bingo",
      `/listWorksheetQuestion/${id} `
    );
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'LIST_QUESTION_OF_WORKSHEET'
            });
    }
  }
};

export const handleDeleteWorksheetId = (id) => async (dispatch) => {
  try {
    const workSheetData = await apis.del(
      "oneway_bingo",
      `/deleteQuestionBank/${id} `
    );
    if (workSheetData) {
      await dispatch(Actions.deleteQuestionByID(id));
    }
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'DELETE_WORKSHEET_ID'
            });
    }
  }
};

export const handleDeleteWorksheet = (id, classId, worksheetData = null, isItAssigned = false, class_ids = []) => async (dispatch) => {
  try {
    let worksheet = worksheetData;
    
    if (!worksheet) {
      const listData = await apis.post("oneway_bingo", `/listWorksheet`, {
        body: {
          chapter: '',
          role: '',
          user_id: '',
          limit: 1000,
          offset: 0,
          status: true,
        },
      });
      worksheet = Array.isArray(listData) ? listData.find((w) => w.id === id) : null;
    }

    if (worksheet && worksheet.share_list && Array.isArray(worksheet.share_list) && worksheet.share_list.length > 0 && worksheet.share_by) {
      try {
        const firestore = getFirestore(firebaseApp);
        const shareId = worksheet.share_by || worksheet.user_id;
        const generated_session_id = shareId + worksheet.id;
        const docRef = doc(firestore, "share_notifications", generated_session_id);
        await deleteDoc(docRef);
      } catch (firebaseError) {
        console.error('Error deleting Firebase notification:', firebaseError);
        logToSentry({
          message: 'Error deleting Firebase notification for worksheet',
          error: firebaseError,
          module: 'WORKSHEET',
          operation: 'DELETE_WORKSHEET_FIREBASE_NOTIFICATION'
        });
      }
    }

    const workSheetData = await apis.del(
      "oneway_bingo",
      `/deleteWorksheet/${id} `,
      {
        body: {
          class_id: classId,
        },
      }
    );
    if (workSheetData) {
      await dispatch(handleListClassGameActivity(classId))
      // await Promise.all([
      //   dispatch(handleListClassSubmissions(classId)),
      // ]);

      await dispatch(Actions.deleteQuestionByID(id));

    }
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'DELETE_WORKSHEET'
            });
    }
  }
};

export const handleSaveQuestionBank = (data) => async (dispatch) => {
  try {
    const workSheetData = await apis.post(
      "oneway_bingo",
      `/createQuestionBank`,
      {
        body: data,
      }
    );
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'SAVE_QUESTION_BANK'
            });
    }
  }
};

export const handleSaveTeachersQuestion = async (data) => {
  try {
    const workSheetData = await apis.post("oneway_bingo", `/fetchTeacherBank`, {
      body: data,
    });
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'SAVE_TEACHERS_QUESTION'
            });
    }
  }
};

export const handleGetWorksheetAssignedClassIds = (userId, bookId) => async (dispatch) => {
  try {
    const response = await apis.post("oneway_bingo", `/worksheetAssignedClasses`, {
      body: {
        user_id: userId,
        book_id: bookId,
      },
    });
    await dispatch(updateUI({ grammer_drill_assigned_class: response }));
    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'Error in operation',
        error,
        module: 'WORKSHEET',
        operation: 'GET_WORKSHEET_ASSIGNED_CLASSES',
      });
    }
    return [];
  }
};

export const handleUpdateWorksheetBank = (data) => async (dispatch) => {
  try {
    const workSheetData = await apis.put(
      "oneway_bingo",
      `/updateWorksheetBank`,
      {
        body: data,
      }
    );
    if (workSheetData) {
      await dispatch(Actions.updateQuestionBank(workSheetData));
    }
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'UPDATE_WORKSHEET_BANK'
            });
    }
  }
};

export const handleUpdateWorksheetStatus = (data) => async (dispatch) => {
  try {
    const workSheetData = await apis.put(
      "oneway_bingo",
      `/updateWorksheetStatus`,
      {
        body: data,
      }
    );
    if (workSheetData) {
      await dispatch(Actions.updateQuestionBank(workSheetData));
    }
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'UPDATE_WORKSHEET_STATUS'
            });
    }
  }
};

export const handleUpdateWorksheetVerified = (data) => async (dispatch) => {
  try {
    const workSheetData = await apis.put(
      "oneway_bingo",
      `/updateWorksheetVerified`,
      {
        body: data,
      }
    );
    if (workSheetData) {
      await dispatch(Actions.updateQuestionBank(workSheetData));
    }
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'UPDATE_WORKSHEET_VERIFIED'
            });
    }
  }
};

export const handleAddOrUpdateOneWorksheet = (data) => async (dispatch) => {
  dispatch(Actions.updateWorksheetImage(data));
};

export const handleUpdateWorksheetName = (payload) => async (dispatch) => {
  try {
    const { id, display_name, user_id } = payload;

    if (!id || !display_name) {
      console.error("Missing required fields for updating worksheet name");
      return { success: false, error: "Missing required fields" };
    }

    const workSheetData = await apis.put("oneway_bingo", `/updateWorksheet`, {
      body: {
        id,
        display_name,
        user_id: user_id || "",
      },
    });

    if (workSheetData) {
      await dispatch(Actions.updateQuestionBank(workSheetData));
      return { success: true, data: workSheetData };
    } else {
      return { success: false, error: "Failed to update worksheet name" };
    }
  } catch (error) {
    console.error("Error updating worksheet name:", error);
    if (error && error.message !== "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'ADD_OR_UPDATE_ONE_WORKSHEET'
            });
    }
    return { success: false, error: error.message || "An error occurred" };
  }
};

export const handleCloneWorksheet = (payload) => async (dispatch) => {
  try {
    const { worksheet_id, user_id, display_name } = payload;

    if (!worksheet_id || !user_id) {
      console.error("Missing required fields for cloning worksheet");
      return { success: false, error: "Missing required fields" };
    }

    const clonedWorksheet = await apis.post("oneway_bingo", `/cloneWorksheet`, {
      body: {
        worksheet_id,
        user_id,
        display_name: display_name || "",
      },
    });

    if (clonedWorksheet && clonedWorksheet.id) {
      return { success: true, data: clonedWorksheet };
    } else {
      return { success: false, error: clonedWorksheet?.error || "Failed to clone worksheet" };
    }
  } catch (error) {
    console.error("Error cloning worksheet:", error);
    if (error && error.message !== "Network Error") {
      logToSentry({
        message: 'Error in operation',
        error,
        module: 'WORKSHEET',
        operation: 'CLONE_WORKSHEET'
      });
    }
    return { success: false, error: error.message || "An error occurred" };
  }
};

export const handleUpdateWorkSheetLog = async (data) => {
  try {
    const workSheetData = await apis.post(
      "oneway_bingo",
      `/createWorksheetLog`,
      {
        body: data,
      }
    );
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'UPDATE_WORKSHEET_NAME'
            });
    }
  }
};

export const totalQuestionBank = async () => {
  try {
    const workSheetData = await apis.post("oneway_bingo", `/countForWorkSheet`);
    if (workSheetData && workSheetData.error) {
      throw workSheetData.error;
    }
    const result = workSheetData.data || workSheetData;
    return result;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'Error in operation',
        error,
        module: 'WORKSHEET',
        operation: 'UPDATE_WORK_SHEET_LOG'
      });
    }
  }
};

export const searchAdminWorksheet = async (data) => {
  try {
    const workSheetData = await apis.post("oneway_bingo", `/searchAdminWorksheet`, {
      body: data,
    });
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'SEARCH_ADMIN_WORKSHEET'
            });
    }
  }
};

export const handleDuplicateByAdmin = async (data) => {
  try {
    const workSheetData = await apis.post("oneway_bingo", `/duplicates_by_admin`, {
      body: data,
    });
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'DUPLICATE_BY_ADMIN'
            });
    }
  }
};

export const handleCountPreview = (data) => async (dispatch) => {
  try {
    const workSheetData = await apis.post("oneway_bingo", `/countConfig`, {
      body: data,
    });
    if(workSheetData?.success) {
      await dispatch(updateUI({countConfigWorksheet: workSheetData?.data?.countData}))
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'COUNT_CONFIG'
            });
    }
  }
};

export const handleUpdateWorksheetShareList = (worksheet_id, share_id, current_user_id) => async (dispatch) => {
  try {
    const response = await apis.post('oneway_bingo', `/updateWorksheetShareList`, {
      body: {
        worksheet_id: worksheet_id,
        share_id: share_id,
        user_id: current_user_id
      }
    });
    
    if(response && response.id){
      await dispatch(Actions.updateQuestionBank(response));
    }
    return response;
  } catch (error) {
    if(error && error.message != "Network Error"){
      logToSentry({
        message: 'updating worksheet share list',
        error,
        module: 'WORKSHEET',
        operation: 'UPDATE_WORKSHEET_SHARE_LIST'
      });
    }
    throw error;
  }
};

export const handleGetWorksheetShareByWithMeList = (data) => async () => {
  try {
    const response = await apis.post('oneway_bingo', `/getWorksheetSharedList`, {
      body: data
    });
    return response?.result?.worksheets;
  } catch (error) {
    if(error && error.message != "Network Error"){
      logToSentry({
        message: 'getting worksheet shared list',
        error,
        module: 'WORKSHEET',
        operation: 'GET_WORKSHEET_SHARED_LIST'
      });
    }
    throw error;
  }
};

export const handleUnshareWorksheet = (id, user_id) => async (dispatch) => {
  try {
    const response = await apis.post('oneway_bingo', `/unShareWorksheet`, {
      body: {
        id,
        user_id
      }
    });
    if (response && response.id) {
      let shareList = response.share_list || [];
      if (typeof shareList === 'string') {
        try {
          shareList = JSON.parse(shareList);
        } catch (e) {
          shareList = [];
        }
      }
      
      const isUserInShareList = Array.isArray(shareList) 
        ? shareList.includes(user_id)
        : false;
      
      if (!isUserInShareList && response.user_id !== user_id) {
        await dispatch(Actions.deleteQuestionByID(id));
      } else {
        await dispatch(Actions.updateQuestionBank(response));
      }
    }
    return response;
  } catch (error) {
    if(error && error.message != "Network Error"){
      logToSentry({
        message: 'Error unsharing worksheet',
        error,
        module: 'WORKSHEET',
        operation: 'UNSHARE_WORKSHEET'
      });
    }
    throw error;
  }
};

export const handleRemoveWorkSheet = (id, classId, worksheetData = null, isItAssigned = false, class_ids = []) => async (dispatch) => {
  try {
    let worksheet = worksheetData;

    if (!worksheet) {
      const listData = await apis.post("oneway_bingo", `/listWorksheet`, {
        body: {
          chapter: '',
          role: '',
          user_id: '',
          limit: 1000,
          offset: 0,
          status: true,
        },
      });
      worksheet = Array.isArray(listData) ? listData.find((w) => w.id === id) : null;
    }

    if (worksheet && worksheet.share_list && Array.isArray(worksheet.share_list) && worksheet.share_list.length > 0 && worksheet.share_by) {
      try {
        const firestore = getFirestore(firebaseApp);
        const shareId = worksheet.share_by || worksheet.user_id;
        const generated_session_id = shareId + worksheet.id;
        const docRef = doc(firestore, "share_notifications", generated_session_id);
        await deleteDoc(docRef);
      } catch (firebaseError) {
        console.error('Error deleting Firebase notification:', firebaseError);
        logToSentry({
          message: 'Error deleting Firebase notification for worksheet',
          error: firebaseError,
          module: 'WORKSHEET',
          operation: 'DELETE_WORKSHEET_FIREBASE_NOTIFICATION'
        });
      }
    }

    const workSheetData = await apis.post(
      "oneway_bingo",
      `/removeWorkSheet/${id}`,
      {
        body: {
          class_ids: class_ids,
          current_class_id: classId,
        },
      }
    );
    if (workSheetData) {
      await dispatch(handleListClassGameActivity(classId))
      // Promise.all([
      //   dispatch(handleListClassSubmissions(classId)),
      // ]);
    }
    return workSheetData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'WORKSHEET',
                operation: 'REMOVE_WORKSHEET'
            });
    }
  }
};